/* eslint-disable no-shadow */
/* eslint-disable camelcase */
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import Skeleton from 'react-loading-skeleton';

import { AiOutlineMinus } from 'react-icons/ai';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useToast } from '../../hooks/toast';
import { useCheckoutFunction } from '../../hooks/useCheckoutFunctions';
import { useTranslation } from '../../hooks/useTranslation';
import { StoreState } from '../../store/createStore';
import { customerFavoriteSave } from '../../store/modules/auth/actions';
import { checkoutActionTypes } from '../../store/modules/checkout/types';
import {
  detailsProduct,
  findProduct,
} from '../../store/modules/product/actions';
import {
  ProductActionTypes,
  productData,
  ProductData,
} from '../../store/modules/product/types';
import Loading from '../Loading';
import {
  Action,
  Amount,
  Botton,
  Container,
  IconsActions,
  Image,
  Root,
  Title,
} from './styles';
import { formatQty } from '../../utils/formatyQtd';
import { getQuantityIncrement } from '../../utils/getQuantityIncrement';
import { RoundHelper } from '../../utils/roundHelper';

// Função para padronizar a unidade de referência
// function formatReferenceUnit(un: string | undefined): string {
//   if (un?.toUpperCase() === 'KG') {
//     return 'kg';
//   } else {
//     return 'un';
//   }
// }

// Função para formatar a unidade dinâmica
function formatUnit(qty: number, un: string | undefined): string {
  if (un?.toUpperCase() === 'KG') {
    if (qty >= 1) {
      return `${qty}kg`;
    } else {
      return `${(qty * 1000).toFixed(0)}g`;
    }
  } else {
    return `${qty.toFixed(0)} ${un}`;
  }
}

interface ProductItemProps {
  product: ProductData;
  width?: number | 195;
  height?: number | 270;
  loading?: boolean;
  id?: string;
}

// Função utilitária para decodificar entidades HTML
function decodeHtml(html: string) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

const ProductItem: React.FC<ProductItemProps> = ({
  product,
  loading,
  id,
}: ProductItemProps) => {
  const [isFavorite, setIsFavorite] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading: loadingCheckout, checkout } = useSelector((state: StoreState) => state.checkout);
  const { filters } = useSelector((state: StoreState) => state.product);
  const { user, loading: loadingUser, isSignedIn } = useSelector(
    (state: StoreState) => state.auth,
  );
  const checkoutQuantity = useMemo(() => Number(checkout.items[product.product_id as string]?.quantity || 0), [product, checkout.items]);
  const increment = getQuantityIncrement(product);
  const { handleCheckoutActions } = useCheckoutFunction();
  const { onSetMessage } = useToast();
  const { onTranslation: t } = useTranslation();

  // produto em kg
  const isKg = product?.un === 'Kg';

  useEffect(() => {
    setIsFavorite(false);
    user.favorite?.forEach(item => {
      if (item.id === product?.id) {
        setIsFavorite(true);
      }
    });
  }, [user.favorite, product]);

  const handleDetailsProduct = useCallback(
    async (data: productData, product: any) => {
      switch (data.type) {
        case ProductActionTypes.SEARCH_PRODUCT:
          if (product.products) {
            dispatch(findProduct({ id: product.products.id }));
            dispatch(detailsProduct(product.products));
          }
          history.push(`/produto?id=${product.products.id}`);
          break;

        default:
      }
    },

    [history, dispatch],
  );

  const handleFavorite = useCallback(
    async (product: ProductData) => {
      //konsole.log('handleFavorite: ', product);
      if (!isSignedIn) {
        onSetMessage({
          type: 'error',
          description: t('main.messages_toast.login'),
        });
        return;
      }

      if (user && user.data.id && product.product_id) {
        setIsFavorite(true);
        dispatch(
          customerFavoriteSave(
            user.data.id?.toString(),
            product.product_id?.toString(),
          ),
        );
      }
    },
    [user, dispatch, isSignedIn, onSetMessage, t],
  );

  return (
    <Root id={id}>
      {loading && filters.moreScroll === false ? (
        <>
          <Skeleton duration={2} width={195} height={280} />
        </>
      ) : (
        <>
          {product && (
            <Container>
              <IconsActions>
                <Botton onClick={() => handleFavorite(product)}>
                  {loadingUser ? (
                    <Loading size={28} />
                  ) : isFavorite ? (
                    <FaHeart id="favorite-icon-red" color={'red'} size={25} />
                  ) : (
                    <FaRegHeart id="favorite-icon" size={25} />
                  )}
                </Botton>
              </IconsActions>
              <div
                onClick={() =>
                  handleDetailsProduct(
                    { type: ProductActionTypes.SEARCH_PRODUCT },
                    { products: product && product },
                  )
                }
              >
                <Image>
                  <img
                    id="img-default"
                    src={product?.image_url}
                    alt={product?.short_description}
                    loading="lazy"
                  />
                </Image>
                {/* <ContentStar>
                <AiFillStar size={19} color="#ffb503" />
                <AiFillStar size={19} color="#ffb503" />
                <AiFillStar size={19} color="#ffb503" />
                <AiFillStar size={19} color="#ffb503" />
                <AiStar size={19} color="#999" />
              </ContentStar> */}
                <Title>
                  <span id="title-product">{decodeHtml(String(product?.short_description))}</span>
                </Title>
                <Amount>
                  {/* {isKg ? (
                    <>
                      <div className="reference-price">
                        {RoundHelper.toFormatted(product?.price || 0)}/kg
                      </div>
                      <div className="dynamic-price">
                        {RoundHelper.toFormatted(checkoutQuantity > 0 ? checkout.items[product.product_id as string]?.total : (RoundHelper.toNumber(product?.price) * increment) || 0)}<span className="unit">/{formatUnit(checkoutQuantity > 0 ? checkoutQuantity : increment, product?.un)}</span>
                      </div>
                    </>
                  ) : (
                    <div className="single-price">
                      {RoundHelper.toFormatted(product?.price || 0)}
                    </div>
                  )} */}
                  {
                    (isKg || (!isKg && checkoutQuantity > 0)) && (
                      <div className="reference-price">
                        {RoundHelper.toFormatted(product?.price || 0) + `/${product.un}`}
                      </div>
                    )
                  }
                      
                      <div className="dynamic-price">
                        {RoundHelper.toFormatted(checkoutQuantity > 0 ? checkout.items[product.product_id as string]?.total : (RoundHelper.toNumber(product?.price) * increment) || 0)}
                        {!isKg && checkoutQuantity === 0 ? (<span className="unit">/{product?.un}</span>) : (<span className="unit">/{formatUnit(checkoutQuantity > 0 ? checkoutQuantity : increment, product?.un)}</span>)}
                      </div>
                </Amount>
              </div>
              <Action className="action">
                {!product.services && (
                  <>
                    {!loadingCheckout && checkoutQuantity > 0 && (
                      <Botton
                        id="button-action-decrement"
                        onClick={() => {
                          let newQty;
                          if (isKg) {
                            newQty = Math.max(0, (checkoutQuantity - increment));
                            newQty = Number(newQty.toFixed(3));
                          } else {
                            newQty = Math.max(0, (checkoutQuantity - increment));
                          }
                          const newQtdString = newQty.toFixed(3).replace('.', ',');
                          if (newQty === 0) {
                            handleCheckoutActions(
                              checkoutActionTypes.REMOVE_PLU_CHECKOUT,
                              product.product_id ? product.product_id : '',
                              newQtdString,
                            );
                          } else {
                            handleCheckoutActions(
                              checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT,
                              product.product_id ? product.product_id : '',
                              newQty.toFixed(3)
                            );
                          }
                        }}
                      >
                        {(checkoutQuantity === increment) ? (
                          <FiTrash2 color="var(--primary)" size={15} />
                        ) : (
                          <AiOutlineMinus color="var(--primary)" size={15} />
                        )}
                      </Botton>
                    )}
                    {loadingCheckout && (
                      <Loading size={30} />
                    )}
                    {
                      !loadingCheckout && (
                        checkoutQuantity > 0 && (
                          <input
                            id="input-qtd-product"
                            type="text"
                            value={formatQty(checkoutQuantity.toString(), product?.un)}
                            inputMode="decimal"
                            placeholder="0"
                            disabled
                            style={{ width: 50, textAlign: 'center' }}
                          />
                        )
                      )
                    }
                    {!loadingCheckout && (<Botton
                      id="button-action-increment"
                      onClick={() =>
                        (() => {
                          let newQty;
                          if (isKg) {
                            newQty = Number((checkoutQuantity + increment).toFixed(3));
                          } else {
                            newQty = checkoutQuantity + increment;
                          }
                          if (checkoutQuantity === 0) {
                            handleCheckoutActions(
                              checkoutActionTypes.ADD_PLU_CHECKOUT,
                              product.product_id ? product.product_id : '',
                              newQty.toFixed(3)
                            );
                          } else {
                            handleCheckoutActions(
                              checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT,
                              product.product_id ? product.product_id : '',
                              newQty.toFixed(3)
                            );
                          }
                        })()
                      }
                    >
                      <FiPlus color="green" size={15} />
                    </Botton>)}
                    {/* <Botton
                      onClick={() =>
                        handleCheckoutActions(
                          checkoutActionTypes.ADD_PLU_CHECKOUT,
                          product.product_id ? product.product_id : '',
                        )
                      }
                    >
                      <FaCartPlus color="green" />
                    </Botton> */}
                  </>
                )}
              </Action>
            </Container>
          )}
        </>
      )}
    </Root>
  );
};

export default ProductItem;
